import { useState } from 'react';
import { Button } from '../../components/ui';
import { CertificateView } from './CertificateView';
import type { Certificate } from './CertificateView';

/**
 * "Open the certificate", wherever it is offered.
 *
 * Both sides render the same component from their own payload — TAP's carries
 * the signatory, the factory's does not. Shared so the two documents look
 * identical rather than diverging into two designs of one artefact.
 *
 * Renders nothing when there is no certificate. An order before client
 * sign-off is the ordinary case, not a missing file.
 */
export function CertificateLink({ certificate }: { certificate: Certificate | null | undefined }) {
  const [open, setOpen] = useState(false);
  if (certificate == null) {
    return null;
  }
  if (open) {
    return <CertificateView certificate={certificate} onClose={() => setOpen(false)} />;
  }
  return (
    <Button variant="secondary" size="sm" onClick={() => setOpen(true)}>
      Open certificate {certificate.certificate_no}
    </Button>
  );
}
